import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE, DOWNLOAD_EXCEL } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// ChildCategory - Get All (Read)
export const GetAllDataProduct = createAsyncThunk(
  "masters/product/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.ProductManage.Product}?name=${
          filter?.name || ""
        }&childcategory_id=${filter?.childcategory_id || ""}&subcategory_id=${filter?.subcategory_id || ""}&category_id=${
          filter?.category_id || ""
        }&page=${filter?.page || IDS.PAGE}&per_page=${
          filter?.per_page || IDS.PERPAGE
        }`
      );
      
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Get (Read)
export const GetSingleDataProduct = createAsyncThunk(
  "masters/childcategory/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.ProductManage.Product}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Create (Add)
export const AddDataProduct = createAsyncThunk(
  "masters/product/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.ProductManage.Product, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const BulkProduct = createAsyncThunk(
  "masters/product/bulk",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ProductManage.Product}/bulk`, data);
      if(res?.success){
        return res;
      }else{
      
        return rejectWithValue(res);
      }
    } catch (error) {
     
      
      return rejectWithValue(error.response.data);
    }
  }
);

export const ProductSample = createAsyncThunk(
  "masters/product/sample",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DOWNLOAD_EXCEL(`${APIS.ProductManage.Product}/sample`, {},"Product");
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Update
export const UpdateDataProduct = createAsyncThunk(
  "masters/childcategory/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.ProductManage.Product}/${id}`, formData);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
// {
//     name: data.name,
//     country_id: data.country_id,
//     state_id: data.state_id
// }

// ChildCategory - Delete
export const DeleteDataProduct = createAsyncThunk(
  "masters/childcategory/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.ProductManage.Product}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Status
export const StatusProduct = createAsyncThunk(
  "masters/childcategory/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ProductManage.Product}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Status
export const PopularStatus = createAsyncThunk(
  "masters/childcategory/popularstatus",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ProductManage.Product}/popular/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Status
export const SpecialityStatus = createAsyncThunk(
  "masters/childcategory/specialitystatus",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ProductManage.Product}/speciality/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "product",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllDataProduct.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllDataProduct.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllDataProduct.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingleDataProduct.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingleDataProduct.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingleDataProduct.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AddDataProduct
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddDataProduct
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateDataProduct
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateDataProduct
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (childcategory) => childcategory.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateDataProduct
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteDataProduct
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteDataProduct
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (childcategory) => childcategory.id !== action.payload
        );
      })
      .addCase(DeleteDataProduct
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StatusProduct
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusProduct
        .fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(StatusProduct
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(PopularStatus
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(PopularStatus
        .fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(PopularStatus
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(SpecialityStatus
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SpecialityStatus
        .fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(SpecialityStatus
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(BulkProduct
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(BulkProduct
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(BulkProduct
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(ProductSample
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(ProductSample
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(ProductSample
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      
  },
});

export default Slice.reducer;
